import { render } from "./ChangePlan.vue?vue&type=template&id=29070b76&scoped=true"
import script from "./ChangePlan.vue?vue&type=script&lang=js"
export * from "./ChangePlan.vue?vue&type=script&lang=js"

import "./ChangePlan.vue?vue&type=style&index=0&id=29070b76&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29070b76"]])

export default __exports__